<template>
  <div class="container">
    <el-row style="height: 30px;">
      <el-col :span="24" style="text-align: center">
        <span class="orders__search__title">{{ $route.query.repTitle }}</span>
      </el-col>
    </el-row>
    <el-form ref="reportDetails" id="reportDetails" style="margin-top: 20px;text-align: left" v-loading="loading"
      label-position="right" :model="formParams">
      <el-row>
        <el-col :span="6" v-for=" (item, index) in formParams.params" :key="index">
          <el-form-item v-if="item.show == 1" :label="item.des" label-width="100px" :prop="'params.' + index + '.value'"
            :rules="paramRequired == 2 || item.type == 'string' || item.type == 'int' || item.type == 'select' || item.must == 2 ? [{ required: false }] : [{ required: true, message: '查询条件为必选' }]">
            <template v-if="item.type == 'date' && reportData.repDateType && reportData.repDateType !== 10">
              <el-date-picker v-if='item.name == "startMonth" || item.name == "endMonth"' v-model="item.value"
                class='width100' size="small" type="month" value-format="yyyy-MM" placeholder="选择年月">
              </el-date-picker>
              <el-date-picker class='width100' size="small" v-else v-model="item.value" align="right"
                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期" :picker-options="pickerOptions1">
              </el-date-picker>
            </template>
            <!-- <el-date-picker
              size="small"
              v-if="item.type=='date'&& reportData.repDateType &&reportData.repDateType !== 10"
              v-model="item.value"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"
              :picker-options="pickerOptions1">
            </el-date-picker> -->
            <el-time-picker is-range size="small" v-else-if="item.type == 'datetime'" v-model="item.value"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-time-picker>
            <el-input size="small" clearable v-else-if="item.type == 'string'" v-model="item.value"></el-input>
            <el-input size="small" clearable v-else-if="item.type == 'int'" type="number" v-model="item.value"></el-input>
            <el-select size="small" clearable v-else-if="item.type == 'select'" v-model="item.value" placeholder="请选择">
              <el-option v-for="selectItem in JSON.parse(item.data)" :key="selectItem.id" :label="selectItem.label"
                :value="selectItem.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :offset="1">
          <el-button style="margin-left: 10px;margin-top: 4px" size="small" type="primary" icon="el-icon-search"
            @click="search(filter.page.pageIndex = 1)">查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <ranking-table :tableData="page" :label="titles" :labelId="titles" :exportData="exportData" :export-fn="exportExcel"
      :loading="exportLoading"></ranking-table>
    <el-row style="margin-top: 10px;">
      <el-col :span="24" style="text-align: right">
        <el-pagination @size-change="searchSize" @current-change="searchCurrent" :current-page="filter.page.pageIndex"
          :page-sizes="[10, 20, 50, 200, 500, 1000]" :page-size="filter.page.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="filter.page.totalElements">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/babel">
import RankingTable from './CommonTable'
import { allReportList, reportGet, reportExport, reportDetail, reportDel, reportEdit, reportAdd } from "@/api/statement"; // 报表统计请求
export default {
  data() {
    return {
      filter: {
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalElements: 0,
          totalPages: 10,
          start: ''
        }
      },
      paramRequired: null,
      exportLoading: false,
      editLoading: false,
      page: [],
      titles: [],
      formParams: {
        params: []
      },
      selectData: [],
      exportData: {
        show: false,
        data: [],
        name: '表格',
        type: []
      },
      loading: false,
      reportData: {},
      pickerOptions1: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  mounted() {
    this.init(false)
  },
  watch: {},
  methods: {
    init(closeType) {
      //        this.search()
      this.searchDetail()
      const vm = this
      vm.exportData.name = vm.$route.query.repTitle
      // const postSubmit = $('#reportDetails')  //  阻止表单提交
      // postSubmit.bind('submit', (e) => {
      //   return false
      // })
    },
    editClass(row) {
      const vm = this
      if (row.repId) {  // 编辑
        vm.editLoading = true
        vm.editClassData.title = '编辑报表'
        PlatformService.reportGet(row.repId).then((resultData) => {
          if (resultData.success) {
            resultData.data['title'] = '编辑报表'
            resultData.data['visible'] = true
            vm.editClassData = resultData.data
          }
          vm.editLoading = false
        }).catch(() => {
          vm.editLoading = false
        })
      } else {  // 新增
        vm.editClassData = vm.$lodash.clone(vm.initData)
      }
      vm.editClassData.visible = true
    },
    searchSize(e) {
      const vm = this
      vm.filter.page.pageSize = e
      vm.search()
    },
    searchCurrent(e) {
      const vm = this
      vm.filter.page.pageIndex = e
      vm.search()
    },
    exportExcel() {
      const vm = this
      vm.$refs['reportDetails'].validate(async (valid) => {
        if (!valid) {
          return false
        }
        vm.exportLoading = true;
        const repId = vm.$route.query.repId;
        let reportData = vm.reportData;
        let customConfig = {
          name: `${vm.$route.query.repTitle}报表`
        }
        const searchInquire = this.searchInquire(false)
        let { data, code } = await reportExport(searchInquire, customConfig);
        if (code == 200) {
          vm.$message.success('下载成功')
        }
        vm.exportLoading = false



        // PlatformService.reportExport(searchInquire, { name: vm.$route.query.repTitle }).then((res) => {
        //   if (res.data) {
        //     vm.$message.success('下载成功')
        //   }
        //   vm.exportLoading = false
        // }).catch(() => {
        //   vm.exportLoading = false
        // })
      })
    },
    async searchDetail() {
      const vm = this;
      const repId = vm.$route.query.repId;
      if (repId) {
        let { data, code } = await reportGet(vm.filter.page.pageIndex, vm.filter.page.pageSize, { reportId: repId });
        if (code == 200) {
          data.repDateType = 1;
          vm.reportData = data;
          if (data.params) {
            vm.formParams.params = data.params;
            vm.paramRequired = data.repParamRequired
          }
          if (vm.reportData.repExport === 1) {
            vm.exportData.show = true
          }
          if (vm.reportData.repDateType !== 10) {
            const date = new Date()
            let times = date.getTime()
            const time = date.getTime()
            const yearNow = date.getFullYear()
            const mouthNow = date.getMonth()
            if (vm.reportData.repDateType === 1) {
              date.setFullYear(yearNow - vm.reportData.repDateNumber)
              times = date.getTime() - time
            } else if (vm.reportData.repDateType === 2) {
              let setMouth = mouthNow - vm.reportData.repDateNumber
              if (mouthNow - vm.reportData.repDateNumber < 0) {
                setMouth = 12 + (mouthNow - vm.reportData.repDateNumber)
                date.setFullYear(yearNow - 1)
              }
              date.setMonth(setMouth)
              times = date.getTime() - time
            } else if (vm.reportData.repDateType === 3) {
              times = -vm.reportData.repDateNumber * 24 * 3600000
            }
            vm.pickerOptions1 = {
              // disabledDate(time) {
              //   return time.getTime() > Date.now() || time.getTime() - times < Date.now()
              // },
              shortcuts: [{
                text: '今天',
                onClick(picker) {
                  picker.$emit('pick', new Date())
                }
              }, {
                text: '昨天',
                onClick(picker) {
                  const date = new Date()
                  date.setTime(date.getTime() - 3600 * 1000 * 24)
                  picker.$emit('pick', date)
                }
              }, {
                text: '一周前',
                onClick(picker) {
                  const date = new Date()
                  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                  picker.$emit('pick', date)
                }
              }]
            }
          }
        }

        // PlatformService.reportGet(repId).then((resultData) => {
        //   if (resultData.success) {
        //     vm.reportData = resultData.data;
        //     if (resultData.data.params) {
        //       vm.formParams.params = resultData.data.params;
        //       vm.paramRequired = resultData.data.repParamRequired
        //     }
        //     if (vm.reportData.repExport === 1) {
        //       vm.exportData.show = true
        //     }
        //     if (vm.reportData.repDateType !== 10) {
        //       const date = new Date()
        //       let times = date.getTime()
        //       const time = date.getTime()
        //       const yearNow = date.getFullYear()
        //       const mouthNow = date.getMonth()
        //       if (vm.reportData.repDateType === 1) {
        //         date.setFullYear(yearNow - vm.reportData.repDateNumber)
        //         times = date.getTime() - time
        //       } else if (vm.reportData.repDateType === 2) {
        //         let setMouth = mouthNow - vm.reportData.repDateNumber
        //         if (mouthNow - vm.reportData.repDateNumber < 0) {
        //           setMouth = 12 + (mouthNow - vm.reportData.repDateNumber)
        //           date.setFullYear(yearNow - 1)
        //         }
        //         date.setMonth(setMouth)
        //         times = date.getTime() - time
        //       } else if (vm.reportData.repDateType === 3) {
        //         times = -vm.reportData.repDateNumber * 24 * 3600000
        //       }
        //       vm.pickerOptions1 = {
        //         disabledDate (time) {
        //           return time.getTime() > Date.now() || time.getTime() - times < Date.now()
        //         },
        //         shortcuts: [{
        //           text: '今天',
        //           onClick (picker) {
        //             picker.$emit('pick', new Date())
        //           }
        //         }, {
        //           text: '昨天',
        //           onClick (picker) {
        //             const date = new Date()
        //             date.setTime(date.getTime() - 3600 * 1000 * 24)
        //             picker.$emit('pick', date)
        //           }
        //         }, {
        //           text: '一周前',
        //           onClick (picker) {
        //             const date = new Date()
        //             date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
        //             picker.$emit('pick', date)
        //           }
        //         }]
        //       }
        //     }
        //   }
        // })
      }
    },
    searchInquire(type = true) {
      const vm = this;
      const searchInquire = {
        reportId: vm.$route.query.repId,
        // pageNum: vm.filter.page.pageIndex,
        // pageSize: vm.filter.page.pageSize
      };

      const exportInquire = `?repId=${vm.$route.query.repId}`
      let inquire = '';
      vm.formParams.params.forEach((ele) => {
        if (ele.value) {
          if (ele.name == 'startMonth' || ele.name == 'endMonth') {
            ele.value += '-01'
          }
          // inquire += '&' + ele.name + '=' + ele.value
          searchInquire[ele.name] = ele.value
        }
        if (ele.name == 'doctorId') {
          let user = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user'))
          searchInquire[ele.name] = user.doctorId
        }
      });
      // if (inquire) {
      //   searchInquire['inquire'] = inquire
      // }
      // if (type) {
      //   return searchInquire
      // }

      // return exportInquire + inquire
      return searchInquire
    },
    async search() {
      const vm = this
      vm.$nextTick(async () => {
        vm.loading = true
        const searchInquire = vm.searchInquire()
        vm.$refs['reportDetails'].validate(async (valid) => {
          if (!valid) {
            vm.loading = false
            return false
          }
          const repId = vm.$route.query.repId;
          let { data, code } = await reportDetail(vm.filter.page.pageIndex, vm.filter.page.pageSize, searchInquire);
          if (code == 200) {
            vm.page = data.page.data
            //            vm.formParams.params = resultData.data.params
            vm.titles = data.titles
            vm.filter.page.totalElements = data.page.totalElements
          }
          vm.loading = false
          //             PlatformService.reportDetail(searchInquire).then((resultData) => {
          //               if (resultData.success) {
          //                 vm.page = resultData.data.page.data
          // //            vm.formParams.params = resultData.data.params
          //                 vm.titles = resultData.data.titles
          //                 vm.filter.page.totalElements = resultData.data.page.totalElements
          //               }
          //               vm.loading = false
          //             }).catch(() => {
          //               vm.loading = false
          //             })
        })
        //          if (!searchInquire.inquire) {
        //            vm.$message.error('请选择查询条件')
        //            vm.loading = false
        //            return false
        //          }
      })
    }
  },
  components: {
    RankingTable
  }
}
</script>

<style scoped lang="less">
.container{
  height: 100%;
  background: #fff;
  padding: 20px;
  overflow: auto;
}
.content {
  overflow: hidden !important;

}

.goodsClass {
  text-align: left;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-form-item {
  margin-bottom: 0
}
</style>
